import React, { useState } from 'react';
import auth from '../../Account/Auth';
import be from '../../BE';

function Url({ url, canEdit }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedUrl, setEditedUrl] = useState(url || '');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);

  const handleEditClick = () => {
    if (canEdit) {
      setIsEditing(true);
    }
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await auth.isAuthenticated()
        .then(async () => {
          await be.post('team-manager', '/team/settings/url', { url: editedUrl }, true, true)
            .then((response) => {
              console.log('[team][settings] team URL updated');
            })
            .catch((error) => {
              // Handle 400 error response when URL already exists
              if (error.response && error.response.status === 400) {
                setErrorMessage('This URL already exists.');
              } else {
                console.error('[team][settings] network error while updating team URL:', error);
              }
            });
        })
        .catch((error) => {
          console.error('[team][settings] authentication error while updating team URL:', error);
        });
    } catch (error) {
      console.error(`[team][settings] functional error while updating team URL`);
    } finally {
      setIsLoading(false);
      setIsEditing(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(editedUrl || url);
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 2000);
  };

  return (
    <div>
      <div className="tw-flex tw-items-center">
        {isEditing ? (
          <input
            type="text"
            value={editedUrl}
            onChange={(e) => {
              setEditedUrl(e.target.value);
              setErrorMessage('');
            }}
            className="tw-border tw-border-gray-300 tw-p-1 tw-rounded tw-mr-2"
            disabled={isLoading}
            autoFocus
          />
        ) : (
          <span
            onClick={handleEditClick}
            className="tw-text-sm tw-text-blue-500 hover:tw-underline cursor-pointer tw-flex-grow"
          >
            {editedUrl || 'https://team-url.com'}
          </span>
        )}
        {canEdit && (
          <button
            onClick={isEditing ? handleSave : handleEditClick}
            className="tw-text-gray-600 tw-hover:text-gray-800"
            disabled={isLoading}
          >
            {isLoading ? (
              <div role="status">
                {/* Loading spinner SVG */}
                <svg
                  aria-hidden="true"
                  className="tw-inline tw-w-4 tw-h-4 tw-text-gray-200 tw-animate-spin dark:tw-text-gray-600 tw-fill-black"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              </div>
            ) : isEditing ? (
              <i className="fas fa-check tw-mx-1 tw-px-1" aria-hidden="true"></i>
            ) : (
              <i className="fas fa-pencil-alt tw-mx-1 tw-px-1" aria-hidden="true"></i>
            )}
          </button>
        )}
        {/* Copy and Open link buttons are only shown when not editing */}
        {!isEditing && (
          <>
            {/* Copy button */}
            <button
              onClick={handleCopy}
              className="tw-p-1 tw-mx-1 tw-text-gray-600"
              disabled={isLoading}
            >
              {copySuccess ? (
                <i className="fas fa-check"></i>
              ) : (
                <i className="fa-solid fa-copy"></i>
              )}
            </button>
            {/* Open link button */}
            <a
              href={editedUrl || url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="tw-p-1 tw-mx-1 tw-text-gray-600"
            >
              <i className="fa-solid fa-up-right-from-square"></i>
            </a>
          </>
        )}
      </div>
      {errorMessage && <p className="tw-text-red-500 tw-text-sm">{errorMessage}</p>}
    </div>
  );
}

export default Url;

